import { DatasetDataInfo } from "models/dataset-models";
import { InstantDoubleValue } from "../api/model/dataset/InstantDoubleValue";

// eslint-disable-next-line import/prefer-default-export
export const formatDatasetValue = (dataset:DatasetDataInfo, data: InstantDoubleValue | null | undefined) =>
    data ? data.value?.toFixed(dataset?.decimalPlaces ?? 2) : "N/A";
